const authTypes = {
  AUTH_SUCCESS: "AUTH_SUCCESS",
  AUTH_LOADING: "AUTH_LOADING",
  GET_USER_PROFILE_SUCCESS: "GET_USER_PROFILE_SUCCESS",
  UPDATE_USER_PROFILE_SUCCESS: "UPDATE_USER_PROFILE_SUCCESS",
  LOGOUT_SUCCESS: "LOGOUT_SUCCESS",
};

export default authTypes;
